import "./events.css"



export function Events(){
      const schemaData = {
                "@context": "https://schema.org",
                "@type" : "Event",
                "about" : "Events where people can come and purchase our food items in person",
                "eventSchdeule" : "Fridays - 8 A.M. to 12 P.M. and Saturdays - 8 A.M. to  12 P.M.",
                "keywords" : "Sourdough Whole Wheat,Organic Breads,Microgreens,Fresh Pasta,Sunflower Pesto,Vegan Butter,gourmet mushrooms",
                "description" : "We do two different farmers markets, where you can come and get our whole foods",
                "location" : "Friday's event is at 8535 E. Speedway and Saturday's event is at 9848 E. Old Vail Rd"

            }
    return(
       

         
        <div className="event-hero">
             <title>Where to find us</title>
          
            <h1 id="event-header">Find Us Fresh in Tucson</h1>
            <p id="header-span">Skip the grocery store lines and support local. Pre-order for fast pick up.</p>
            <div id="market-list">
                <p className="market-list">Fridays - Rustic Roots Farmers Market</p>
                <span className="list-span">8535 E. Speedway 8 A.M. - 12 P.M.</span>
                <p className="market-list">Saturdays - Rustic Roots Farmers Market</p>
                <span className="list-span">9848 E. Old Vail Rd. 8 A.M. - 12 P.M.</span>

            </div>
                  
        </div>
    )
}